import EquipmentTableFilter from './equipment-table-filter';

export default EquipmentTableFilter;